<template>
  <div class="timetable" >
    <Header title="实验课程表"></Header>
    <div class="timetable_top">
      <div class="timetable_top-left">
        <template >
          <van-field
            style="margin-left: 12px;width: 110px;"
            readonly
            clickable
            placeholder=""
            v-model="xnxq.text"
            @click="showXnxqPicker = true"
          />
          <i class="el-icon-caret-bottom"></i>
        </template>
        <template >
          <van-field
            style="margin-left: 12px;width: 60px;"
            readonly
            clickable
            :value="curWeek"
            @click="
              showPicker = true;
              change = false;
            "
          />
        </template>
        <i class="el-icon-caret-bottom"></i>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
            :item-height="35"
            :default-index="defaultIndex"
          />
        </van-popup>
        <van-popup v-model="showXnxqPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="xnxqcolumns"
            @cancel="showXnxqPicker = false"
            @confirm="onXnxqConfirm"
            :item-height="35"
            :default-index="defaultIndex"
          />
        </van-popup>
      </div>
      <div class="time-right-stu">
        <div class="currentTime" @click="loadCourse()">本周</div>
      </div>
    </div>
    <div class="timetable_list">
      <div class="period">
        <div>
          <template>
            {{ this.curMonth }}<br />月</template
          >
        </div>
        <ul >
          <li v-for="(item,index) in nodeList" :key="index">{{item.nodeNumber}}</li>
          <li></li>
        </ul>
      </div>
      <div class="table-right" id="tableRight">
        <div class="week-nav">
          <ul>
            <li
              :class="{ currentDay: (curDay == item.xqmc && curWeek == stillWeek) }"
              v-for="(item, index) in dateWeekList"
              :key="index"
            >
              <span>周{{ item.xqmc }}</span>
              <template>
                <p>{{ dateSub(item.mxrq) }}</p>
              </template>
            </li>
          </ul>
        </div>
        <div class="course-content-box">
          <div class="day-hr" v-for="(item, index) in nodeList" :key="index" :style="`bottom: ${(index + 1) * 131}px`" /> 
          <div class="course-content" style="margin-bottom: 60px;">
            <!-- 周日 -->
            <div class="course-form" id="Sunday">
              <ul class="double-item">
                <template v-for="(list, active) in SundayList">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                          <p
                            v-if="item.buttonCode != 0 && item.buttonCode"
                            v-text="
                              item.buttonCode == 2 ? '进入课堂' : '暂未开设'
                            "
                          ></p>
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in SundayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
            <!-- 周一 -->
            <div class="course-form" id="monday">
              <ul class="double-item">
                <template v-for="(list, active) in mondayList">
                  <template v-for="(elem, num) in list">
                    @{{ elem }}@
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 1, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in mondayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 1, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
            <!-- 周二 -->
            <div class="course-form" id="Tuesday">
              <ul class="double-item">
                <template v-for="(list, active) in TuesdayList">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in TuesdayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
            <!-- 周三 -->
            <div class="course-form" id="Wednesday">
              <ul class="double-item">
                <template v-for="(list, active) in WednesdayList">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 1, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in WednesdayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 1, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
            <!-- 周四 -->
            <div class="course-form" id="Thursday">
              <ul class="double-item">
                <template v-for="(list, active) in ThursdayList">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in ThursdayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
            <!-- 周五 -->
            <div class="course-form" id="Friday">
              <ul class="double-item">
                <template v-for="(list, active) in FridayList">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 1, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in FridayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 1, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
            <!-- 周六 -->
            <div class="course-form" id="Saturday">
              <ul class="double-item">
                <template v-for="(list, active) in SaturdayList">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined ? '' : 'course-color'
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
              <ul class="single-item">
                <template v-for="(list, active) in SaturdayList1">
                  <template v-for="(elem, num) in list">
                    <li
                      ref="ranText"
                      :class="
                        elem[0].courseName == undefined
                          ? ''
                          : 'course-color upShow'
                      "
                      :style="
                        'margin-top:' +
                          calcOpt(elem[0].classTime, 0) +
                          'height:' +
                          calcOpt(elem[0].classTime, 1)
                      "
                      :key="active + num"
                      v-if="elem"
                      @click="courseDetail(elem)"
                    >
                      <van-swipe
                        class="my-swipe"
                        :autoplay="0"
                        indicator-color="white"
                        :loop="false"
                        @change="
                          index => {
                            return onChange(index, elem);
                          }
                        "
                      >
                        <van-swipe-item
                          v-for="(item, index) in elem"
                          :key="index"
                          :style="
                            item.courseName
                              ? 'background-color:' + calcColor(index, 0, num)
                              : ''
                          "
                        >
                          {{
                            item.courseName == undefined
                              ? ""
                              : item.courseName +
                                "-" +
                                item.teacherName +
                                "@" +
                                item.location 
                          }}
                        </van-swipe-item>
                        <template #indicator>
                          <div v-if="elem.length > 1" class="custom-indicator">
                            {{ elem.current + 1 }}/{{ elem.length }}
                          </div>
                        </template>
                      </van-swipe>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="popShow" class="popup">
      <h2>
        <i class="close-pop" @click="popShow = false"></i>
      </h2>
      <div
        class="popup-content"
        v-for="(item, index) in this.popList"
        :key="index"
      >
      <p>
          课程名称：<span>{{ item.courseName }}</span>
        </p>
        <p >
          班级：<span
            >{{ item.ktmc }}</span
          >
        </p>
        <p >
          时间：<span
            >{{ item.classTime }}</span
          >
        </p>
        <p>
          地点：<span>{{ item.location }}</span>
        </p>
        <p>
          教师：<span>{{ item.teacherName }}</span>
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      active: 0,
      wkbkcList:[],
      jxrwList:[],
      BottomDiv: "",
      schoolCode: "",
      casLogin: sessionStorage.getItem("casLogin"),
      isAllow: "",
      timetable: [],
      curWeek: "",
      xnxq:{
        text:'',
        val:''
      },
      modePicker: false,
      showPicker: false,
      showXnxqPicker:false,
      defaultIndex: 0,
      defaultIndex1: 0,
      columns: [ {
          values: [],
          className: "column1"
        }],
      xnxqcolumns: [ {
        values: [],
        className: "column1"
      }],
      modeColumns: [],
      nodeList:[],
      curDay: "",
      popShow: false,
      popList: [
        {
          classNum: "",
          classTime: "",
          classWeek: "",
          classWeekDetails: "",
          courseName: "",
          endTIme: "",
          jx0408id: "",
          location: "",
          startTime: "",
          teacherName: "",
          weekday: ""
        }
      ],
      buttonCodeFlag:'0',
      allCourseList: "",
      mondayList: [],
      TuesdayList: [],
      WednesdayList: [],
      ThursdayList: [],
      FridayList: [],
      SaturdayList: [],
      SundayList: [],
      // 单节
      mondayList1: [],
      TuesdayList1: [],
      WednesdayList1: [],
      ThursdayList1: [],
      FridayList1: [],
      SaturdayList1: [],
      SundayList1: [],
      weekPick: "",
      stillWeek: "",
      infoWeek: "",
      curMonth: "",
      dateWeekList: [],
      colorList: ["#FF8282", "#EE7BFF", "#FFBB79", "#FF87B3", "#86B5FF"],
      colorList1: [
        "rgba(118,107,255,.7)",
        "#757DA3",
        "rgba(255,84,147,.4)",
        "#B3B9D0",
        "rgba(95,222,255,.7)"
      ],
      updateUrl: "",
      change: true,
      timeModeId: "",
      modeIdColumns: [],
      studentsList: [],
      needClassName:'0',
      needClassRoomNub:'0',
      kbsfxs: window.__config__.KB_ISBZ,
      xskcShow:true,
      xskcInfo:'',
      xskcInfoDetail:'',
      xskcxsDetailPopup: false,
      zcList: [],
      xnxqidArr:[],
      bz_show:true,
      BottomDiv_bz:'',
    };
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.loadCourse();
    this.timeModeTap();
  },
  methods: {
    onChange(index, elem) {
      elem.current = index;
    },
    calcColor(index, type, active) {
      index = index + active;
      if (this.change) {
        // let num = parseInt(Math.random()*5)
        let num = Math.abs(index - 2) % 5;
        let num1 = Math.abs(index - 4) % 5;
        if (type == 0) {
          return this.colorList[num1];
        } else {
          return this.colorList1[num];
        }
      }
    },
    modeConfirm(val, index) {
      this.modePicker = false;
      this.timeMode = val;
      this.timeModeId = this.modeIdColumns[index];
      this.loadCourse(this.modeIdColumns[index]);
    },
    calcOpt(val, type) {
      let num = Number(val.substr(1, 2)) - 1;
      //top
      if (type == 0) {
        return num * 65.5 + "px;";
        //height
      } else {
        let multiple = (Number(val.length) - 1) / 2;
        return 65.5 * multiple + "px;";
      }
    },
    dateSub(res) {
      return Number(res.substr(-2, 2));
    },
    async getTeaWeek() {
      const res = await Api.getTeachingWeek();
      let concatList = [];
      this.columns = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          text: "第" + item.week + "周",
          value: index + 1
        };
      });
      this.columns = this.columns.concat(concatList);
    },
    async getXnxq() {
      const res = await Api.findDictionry({ zzdtype: "xnxq" });
      if (res.code == 1) {
        let defaultIndexXnxq = 0;
        this.xnxqcolumns = [
          {
            values: res.data.xnxq.map((item, index) => {
              if (item.isdqxq === "1") {
                defaultIndexXnxq = index;
                this.xnxq  = {
                  text: item.xqmc,
                  val: item.xnxq01id
                };
              }
              return {
                text: item.xqmc,
                value: item.xnxq01id
              };
            }),
            defaultIndex: defaultIndexXnxq
          }
        ];
      }
    },
    async timeModeTap() {
      const res = await Api.getTimeMode();
      res.data.forEach((item, index) => {
        if (item.mrms == 1) {
          this.timeMode = item.kbjcmsmc;
          this.defaultIndex1 = index;
          this.timeModeId = item.kbjcmsid;
        }
        this.modeColumns.push(item.kbjcmsmc);
        this.modeIdColumns.push(item.kbjcmsid);
      });
    },
    async curriculum(val, e,xnxqval) {
      const params = {
        week: val ? val : "",
        kbjcmsid: e ? e : "",
        xnxqid: xnxqval == '' ? xnxqval : this.xnxq.val 
      };
      const res = await Api.getSycurriculum(params);
      
      if(res.data[0]!=null&&res.data[0].bz!=null){
        this.BottomDiv = res.data[0].bz;
      }
      
      if(!this.BottomDiv_bz||this.BottomDiv_bz==''){
        this.bz_show = false;
      }
      
      this.nodeList = res.data[0].nodesLst;
      
      this.dateWeekList = res.data[0].date;
      if (res.data.length != 0) {
        this.curWeek = "第" + res.data[0].week + "周";
        this.stillWeek = "第" + res.data[0].week + "周";
        this.curDay = res.data[0].weekday;
        this.allCourseList = res.data[0].item;

        this.defaultIndex = Number(res.data[0].week) - 1;
        this.curMonth = Number(res.data[0].date[0].mxrq.substr(5, 2));
        if (res.data[0].item.length == 0) {
          this.$toast.fail(res.Msg);
        } else {
          let mondayList1 = [];
          let TuesdayList1 = [];
          let WednesdayList1 = [];
          let ThursdayList1 = [];
          let FridayList1 = [];
          let SaturdayList1 = [];
          let SundayList1 = [];

          for (let i of this.allCourseList) {
            for (let j of i) {
              j.current = 0;
            }
          }

          //当前周次全部课程
          mondayList1.push(this.allCourseList[0]);

          TuesdayList1.push(this.allCourseList[1]);

          WednesdayList1.push(this.allCourseList[2]);

          ThursdayList1.push(this.allCourseList[3]);

          FridayList1.push(this.allCourseList[4]);

          SaturdayList1.push(this.allCourseList[5]);

          SundayList1.push(this.allCourseList[6]);

          let mondayList = [];
          let TuesdayList = [];
          let WednesdayList = [];
          let ThursdayList = [];
          let FridayList = [];
          let SaturdayList = [];
          let SundayList = [];
          for (let x = 0; x < 6; x++) {
            mondayList[x] = {};
            TuesdayList[x] = {};
            WednesdayList[x] = {};
            ThursdayList[x] = {};
            FridayList[x] = {};
            SaturdayList[x] = {};
            SundayList[x] = {};
          }
          if (this.mondayList.length > 0) {
            for (let y = 0; y < this.mondayList.length; y++) {
              let mIndex =
                (Number(this.mondayList[y].classTime.substr(1, 2)) - 1) / 2;
              mondayList[mIndex] = this.mondayList[y];
            }
          }
          if (this.TuesdayList.length > 0) {
            for (let y = 0; y < this.TuesdayList.length; y++) {
              let tIndex =
                (Number(this.TuesdayList[y].classTime.substr(1, 2)) - 1) / 2;
              TuesdayList[tIndex] = this.TuesdayList[y];
            }
          }
          if (this.WednesdayList.length > 0) {
            for (let y = 0; y < this.WednesdayList.length; y++) {
              let wIndex =
                (Number(this.WednesdayList[y].classTime.substr(1, 2)) - 1) / 2;
              WednesdayList[wIndex] = this.WednesdayList[y];
            }
          }
          if (this.ThursdayList.length > 0) {
            for (let y = 0; y < this.ThursdayList.length; y++) {
              let hIndex =
                (Number(this.ThursdayList[y].classTime.substr(1, 2)) - 1) / 2;
              ThursdayList[hIndex] = this.ThursdayList[y];
            }
          }
          if (this.FridayList.length > 0) {
            for (let y = 0; y < this.FridayList.length; y++) {
              let fIndex =
                (Number(this.FridayList[y].classTime.substr(1, 2)) - 1) / 2;
              FridayList[fIndex] = this.FridayList[y];
            }
          }
          if (this.SaturdayList.length > 0) {
            for (let y = 0; y < this.SaturdayList.length; y++) {
              let sIndex =
                (Number(this.SaturdayList[y].classTime.substr(1, 2)) - 1) / 2;
              SaturdayList[sIndex] = this.SaturdayList[y];
            }
          }
          if (this.SundayList.length > 0) {
            for (let y = 0; y < this.SundayList.length; y++) {
              let uIndex =
                (Number(this.SundayList[y].classTime.substr(1, 2)) - 1) / 2;
              SundayList[uIndex] = this.SundayList[y];
            }
          }
          if (res.data[0].date[0].xqmc == "日") {
            this.mondayList = mondayList;
            this.TuesdayList = TuesdayList;
            this.WednesdayList = WednesdayList;
            this.ThursdayList = ThursdayList;
            this.FridayList = FridayList;
            this.SaturdayList = SaturdayList;
            this.SundayList = SundayList;

            this.mondayList1 = mondayList1;
            this.TuesdayList1 = TuesdayList1;
            this.WednesdayList1 = WednesdayList1;
            this.ThursdayList1 = ThursdayList1;
            this.FridayList1 = FridayList1;
            this.SaturdayList1 = SaturdayList1;
            this.SundayList1 = SundayList1;
          } else if (res.data[0].date[0].xqmc == "一") {
            this.mondayList = TuesdayList;
            this.TuesdayList = WednesdayList;
            this.WednesdayList = ThursdayList;
            this.ThursdayList = FridayList;
            this.FridayList = SaturdayList;
            this.SaturdayList = SundayList;
            this.SundayList = mondayList;

            this.mondayList1 = TuesdayList1;
            this.TuesdayList1 = WednesdayList1;
            this.WednesdayList1 = ThursdayList1;
            this.ThursdayList1 = FridayList1;
            this.FridayList1 = SaturdayList1;
            this.SaturdayList1 = SundayList1;
            this.SundayList1 = mondayList1;
          } else if (res.data[0].date[0].xqmc == "二") {
            this.mondayList = WednesdayList;
            this.TuesdayList = ThursdayList;
            this.WednesdayList = FridayList;
            this.ThursdayList = SaturdayList;
            this.FridayList = SundayList;
            this.SaturdayList = mondayList;
            this.SundayList = TuesdayList;

            this.mondayList1 = WednesdayList1;
            this.TuesdayList1 = ThursdayList1;
            this.WednesdayList1 = FridayList1;
            this.ThursdayList1 = SaturdayList1;
            this.FridayList1 = SundayList1;
            this.SaturdayList1 = mondayList1;
            this.SundayList1 = TuesdayList1;
          } else if (res.data[0].date[0].xqmc == "三") {
            this.mondayList = ThursdayList;
            this.TuesdayList = FridayList;
            this.WednesdayList = SaturdayList;
            this.ThursdayList = SundayList;
            this.FridayList = mondayList;
            this.SaturdayList = TuesdayList;
            this.SundayList = WednesdayList;

            this.mondayList1 = ThursdayList1;
            this.TuesdayList1 = FridayList1;
            this.WednesdayList1 = SaturdayList1;
            this.ThursdayList1 = SundayList1;
            this.FridayList1 = mondayList1;
            this.SaturdayList1 = TuesdayList1;
            this.SundayList1 = WednesdayList1;
          } else if (res.data[0].date[0].xqmc == "四") {
            this.mondayList = FridayList;
            this.TuesdayList = SaturdayList;
            this.WednesdayList = SundayList;
            this.ThursdayList = mondayList;
            this.FridayList = TuesdayList;
            this.SaturdayList = WednesdayList;
            this.SundayList = ThursdayList;

            this.mondayList1 = FridayList1;
            this.TuesdayList1 = SaturdayList1;
            this.WednesdayList1 = SundayList1;
            this.ThursdayList1 = mondayList1;
            this.FridayList1 = TuesdayList1;
            this.SaturdayList1 = WednesdayList1;
            this.SundayList1 = ThursdayList1;
          } else if (res.data[0].date[0].xqmc == "五") {
            this.mondayList = SaturdayList;
            this.TuesdayList = SundayList;
            this.WednesdayList = mondayList;
            this.ThursdayList = TuesdayList;
            this.FridayList = WednesdayList;
            this.SaturdayList = ThursdayList;
            this.SundayList = FridayList;

            this.mondayList1 = SaturdayList1;
            this.TuesdayList1 = SundayList1;
            this.WednesdayList1 = mondayList1;
            this.ThursdayList1 = TuesdayList1;
            this.FridayList1 = WednesdayList1;
            this.SaturdayList1 = ThursdayList1;
            this.SundayList1 = FridayList1;
          } else if (res.data[0].date[0].xqmc == "六") {
            this.mondayList = SundayList;
            this.TuesdayList = mondayList;
            this.WednesdayList = TuesdayList;
            this.ThursdayList = WednesdayList;
            this.FridayList = ThursdayList;
            this.SaturdayList = FridayList;
            this.SundayList = SaturdayList;

            this.mondayList1 = SundayList1;
            this.TuesdayList1 = mondayList1;
            this.WednesdayList1 = TuesdayList1;
            this.ThursdayList1 = WednesdayList1;
            this.FridayList1 = ThursdayList1;
            this.SaturdayList1 = FridayList1;
            this.SundayList1 = SaturdayList1;
          }
        }
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    loadCourse(e) {
      this.change = true;
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];
      this.allCourseList = [];

      this.mondayList1 = [];
      this.TuesdayList1 = [];
      this.WednesdayList1 = [];
      this.ThursdayList1 = [];
      this.FridayList1 = [];
      this.SaturdayList1 = [];
      this.SundayList1 = [];

      let mondayList1 = [];
      let TuesdayList1 = [];
      let WednesdayList1 = [];
      let ThursdayList1 = [];
      let FridayList1 = [];
      let SaturdayList1 = [];
      let SundayList1 = [];
      this.getTeaWeek();
      this.getXnxq();
      // 课程表
      let defaultIndex = "";
      let xnxqval = "";
      if (e) {
        defaultIndex = this.defaultIndex + 1;
      } else {
        defaultIndex = "";
      }
      this.curriculum(defaultIndex, e,xnxqval);
    },
    courseDetail(arr) {
      let info = arr[0];
      let day = Number(info.classTime.substr(0, 1));
      this.change = false;
      switch (day) {
        case 1:
          this.infoWeek = "周一";
          break;
        case 2:
          this.infoWeek = "周二";
          break;
        case 3:
          this.infoWeek = "周三";
          break;
        case 4:
          this.infoWeek = "周四";
          break;
        case 5:
          this.infoWeek = "周五";
          break;
        case 6:
          this.infoWeek = "周六";
          break;
        case 7:
          this.infoWeek = "周日";
          break;
        default:
          break;
      }
      this.popShow = true;
      this.popList = arr;
      this.buttonCodeFlag = arr[0].buttonCode;
    
      this.infoWeek =
        this.infoWeek +
        "，" +
        info.classTime.substr(1, info.classTime.length) +
        "节";
    },
    onConfirm(value, index) {
      this.change = true;
      this.weekPick = value.text;
      this.showPicker = false;
      this.courseTable(index + 1);
      
      this.curWeek = value.text;
      this.defaultIndex = index;
      
    },
    onXnxqConfirm(value, index) {
      this.change = true;
      this.xnxq.text = value[0].text;
      this.xnxq.val = value[0].value;
      this.showXnxqPicker = false;
      this.courseTable(this.defaultIndex+1);
    },
    courseTable(val) {
      this.mondayList = [];
      this.TuesdayList = [];
      this.WednesdayList = [];
      this.ThursdayList = [];
      this.FridayList = [];
      this.SaturdayList = [];
      this.SundayList = [];
      this.mondayList1 = [];
      this.TuesdayList1 = [];
      this.WednesdayList1 = [];
      this.ThursdayList1 = [];
      this.FridayList1 = [];
      this.SaturdayList1 = [];
      this.SundayList1 = [];
      this.allCourseList1 = [];

      let mondayList1 = [];
      let TuesdayList1 = [];
      let WednesdayList1 = [];
      let ThursdayList1 = [];
      let FridayList1 = [];
      let SaturdayList1 = [];
      let SundayList1 = [];
      let allCourseList1 = [];
      this.getCurriculum(val);
    },
    async getCurriculum(val) {
      var params = {
        week: val,
        kbjcmsid: this.timeModeId,
        xnxqid: this.xnxq.val
      };
      const res = await Api.getSycurriculum(params);
      this.nodeList = res.data[0].nodesLst;
      this.dateWeekList = res.data[0].date;
      if (res.data.length != 0) {
        this.allCourseList = res.data[0].item;
        this.curMonth = Number(res.data[0].date[0].mxrq.substr(5, 2));
        if (res.data[0].item.length == 0) {
          this.$toast.fail("当前周次暂无课表信息~");
        } else {
          let mondayList1 = [];
          let TuesdayList1 = [];
          let WednesdayList1 = [];
          let ThursdayList1 = [];
          let FridayList1 = [];
          let SaturdayList1 = [];
          let SundayList1 = [];
          //当前周次全部课程
          for (let i of this.allCourseList) {
            for (let j of i) {
              j.current = 0;
            }
          }
          //当前周次全部课程
          mondayList1.push(this.allCourseList[0]);

          TuesdayList1.push(this.allCourseList[1]);

          WednesdayList1.push(this.allCourseList[2]);

          ThursdayList1.push(this.allCourseList[3]);

          FridayList1.push(this.allCourseList[4]);

          SaturdayList1.push(this.allCourseList[5]);

          SundayList1.push(this.allCourseList[6]);
          
          let mondayList = [];
          let TuesdayList = [];
          let WednesdayList = [];
          let ThursdayList = [];
          let FridayList = [];
          let SaturdayList = [];
          let SundayList = [];
          for (let x = 0; x < 6; x++) {
            mondayList[x] = {};
            TuesdayList[x] = {};
            WednesdayList[x] = {};
            ThursdayList[x] = {};
            FridayList[x] = {};
            SaturdayList[x] = {};
            SundayList[x] = {};
          }
          if (this.mondayList.length > 0) {
            for (let y = 0; y < this.mondayList.length; y++) {
              let mIndex =
                (Number(this.mondayList[y].classTime.substr(1, 2)) - 1) / 2;
              mondayList[mIndex] = this.mondayList[y];
            }
          }
          if (this.TuesdayList.length > 0) {
            for (let y = 0; y < this.TuesdayList.length; y++) {
              let tIndex =
                (Number(this.TuesdayList[y].classTime.substr(1, 2)) - 1) / 2;
              TuesdayList[tIndex] = this.TuesdayList[y];
            }
          }
          if (this.WednesdayList.length > 0) {
            for (let y = 0; y < this.WednesdayList.length; y++) {
              let wIndex =
                (Number(this.WednesdayList[y].classTime.substr(1, 2)) - 1) / 2;
              WednesdayList[wIndex] = this.WednesdayList[y];
            }
          }
          if (this.ThursdayList.length > 0) {
            for (let y = 0; y < this.ThursdayList.length; y++) {
              let hIndex =
                (Number(this.ThursdayList[y].classTime.substr(1, 2)) - 1) / 2;
              ThursdayList[hIndex] = this.ThursdayList[y];
            }
          }
          if (this.FridayList.length > 0) {
            for (let y = 0; y < this.FridayList.length; y++) {
              let fIndex =
                (Number(this.FridayList[y].classTime.substr(1, 2)) - 1) / 2;
              FridayList[fIndex] = this.FridayList[y];
            }
          }
          if (this.SaturdayList.length > 0) {
            for (let y = 0; y < this.SaturdayList.length; y++) {
              let sIndex =
                (Number(this.SaturdayList[y].classTime.substr(1, 2)) - 1) / 2;
              SaturdayList[sIndex] = this.SaturdayList[y];
            }
          }
          if (this.SundayList.length > 0) {
            for (let y = 0; y < this.SundayList.length; y++) {
              let uIndex =
                (Number(this.SundayList[y].classTime.substr(1, 2)) - 1) / 2;
              SundayList[uIndex] = this.SundayList[y];
            }
          }
          if (res.data[0].date[0].xqmc == "日") {
            this.mondayList = mondayList;
            this.TuesdayList = TuesdayList;
            this.WednesdayList = WednesdayList;
            this.ThursdayList = ThursdayList;
            this.FridayList = FridayList;
            this.SaturdayList = SaturdayList;
            this.SundayList = SundayList;

            this.mondayList1 = mondayList1;
            this.TuesdayList1 = TuesdayList1;
            this.WednesdayList1 = WednesdayList1;
            this.ThursdayList1 = ThursdayList1;
            this.FridayList1 = FridayList1;
            this.SaturdayList1 = SaturdayList1;
            this.SundayList1 = SundayList1;
          } else if (res.data[0].date[0].xqmc == "一") {
          
            this.mondayList = TuesdayList;
            this.TuesdayList = WednesdayList;
            this.WednesdayList = ThursdayList;
            this.ThursdayList = FridayList;
            this.FridayList = SaturdayList;
            this.SaturdayList = SundayList;
            this.SundayList = mondayList;
            
            this.mondayList1 = TuesdayList1;
            this.TuesdayList1 = WednesdayList1;
            this.WednesdayList1 = ThursdayList1;
            this.ThursdayList1 = FridayList1;
            this.FridayList1 = SaturdayList1;
            this.SaturdayList1 = SundayList1;
            this.SundayList1 = mondayList1;
            var cs = {}
            cs = this.SundayList1[0];
          } else if (res.data[0].date[0].xqmc == "二") {
            this.mondayList = WednesdayList;
            this.TuesdayList = ThursdayList;
            this.WednesdayList = FridayList;
            this.ThursdayList = SaturdayList;
            this.FridayList = SundayList;
            this.SaturdayList = mondayList;
            this.SundayList = TuesdayList;

            this.mondayList1 = WednesdayList1;
            this.TuesdayList1 = ThursdayList1;
            this.WednesdayList1 = FridayList1;
            this.ThursdayList1 = SaturdayList1;
            this.FridayList1 = SundayList1;
            this.SaturdayList1 = mondayList1;
            this.SundayList1 = TuesdayList1;
          } else if (res.data[0].date[0].xqmc == "三") {
            this.mondayList = ThursdayList;
            this.TuesdayList = FridayList;
            this.WednesdayList = SaturdayList;
            this.ThursdayList = SundayList;
            this.FridayList = mondayList;
            this.SaturdayList = TuesdayList;
            this.SundayList = WednesdayList;

            this.mondayList1 = ThursdayList1;
            this.TuesdayList1 = FridayList1;
            this.WednesdayList1 = SaturdayList1;
            this.ThursdayList1 = SundayList1;
            this.FridayList1 = mondayList1;
            this.SaturdayList1 = TuesdayList1;
            this.SundayList1 = WednesdayList1;
          } else if (res.data[0].date[0].xqmc == "四") {
            this.mondayList = FridayList;
            this.TuesdayList = SaturdayList;
            this.WednesdayList = SundayList;
            this.ThursdayList = mondayList;
            this.FridayList = TuesdayList;
            this.SaturdayList = WednesdayList;
            this.SundayList = ThursdayList;

            this.mondayList1 = FridayList1;
            this.TuesdayList1 = SaturdayList1;
            this.WednesdayList1 = SundayList1;
            this.ThursdayList1 = mondayList1;
            this.FridayList1 = TuesdayList1;
            this.SaturdayList1 = WednesdayList1;
            this.SundayList1 = ThursdayList1;
          } else if (res.data[0].date[0].xqmc == "五") {
            this.mondayList = SaturdayList;
            this.TuesdayList = SundayList;
            this.WednesdayList = mondayList;
            this.ThursdayList = TuesdayList;
            this.FridayList = WednesdayList;
            this.SaturdayList = ThursdayList;
            this.SundayList = FridayList;

            this.mondayList1 = SaturdayList1;
            this.TuesdayList1 = SundayList1;
            this.WednesdayList1 = mondayList1;
            this.ThursdayList1 = TuesdayList1;
            this.FridayList1 = WednesdayList1;
            this.SaturdayList1 = ThursdayList1;
            this.SundayList1 = FridayList1;
          } else if (res.data[0].date[0].xqmc == "六") {
            this.mondayList = SundayList;
            this.TuesdayList = mondayList;
            this.WednesdayList = TuesdayList;
            this.ThursdayList = WednesdayList;
            this.FridayList = ThursdayList;
            this.SaturdayList = FridayList;
            this.SundayList = SaturdayList;

            this.mondayList1 = SundayList1;
            this.TuesdayList1 = mondayList1;
            this.WednesdayList1 = TuesdayList1;
            this.ThursdayList1 = WednesdayList1;
            this.FridayList1 = ThursdayList1;
            this.SaturdayList1 = FridayList1;
            this.SundayList1 = SaturdayList1;
          }
        }
      } else {
        this.$toast.fail(res.Msg);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.ranText) {
        for (let i = 0; i < this.$refs.ranText.length; i++) {
          if (
            this.$refs.ranText[i].children &&
            this.$refs.ranText[i].children.length == 1
          ) {
            this.$refs.ranText[i].children[0].style.color = this.$refs.ranText[
              i
            ].style.backgroundColor;
          }
        }
      }
    }, 500);
  }
};
</script>

<style lang="less" scoped>
.footerparndiv {
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
  height: 4rem;
  width: 100%;
  border-top: 0.3px solid white;
  .bottomleftdiv {
    display: block;
    line-height: 3rem;
    color: #757dac;
    p {
      margin-left: 10px;
    }
    //  border-right: 0.3px solid #D0D4E5;
    width: 20%;
    height: 4rem;
    background-color: #f4f5ff;
  }
  .bottomrightdiv {
    p {
      margin-top: 7px;
    }
    display: block;
    width: 80%;
    color: red;
    font-size: 10px;
    height: 4rem;
    background-color: #f4f5ff;
  }
}
.timetable .popup i.close-pop {
  background: url(../../../../static/img/close.png) no-repeat center;
  position: absolute;
   right: 10px;
      top: 10px;
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  padding: 10px;
}
.timetable .link-item {
  text-decoration: underline;
  word-break: break-all;
}
.timetable .upShow {
  z-index: 2;
  border-left: 1px solid @attendance-color-3;
}
.timetable .single-item,
.double-item,
.triangle-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.timetable .single-item,
.triangle-item {
  top: 1px;
}
.timetable .van-popup.van-popup--center {
  box-sizing: border-box;
  padding: 40px 20px 20px;
}
.timetable .van-popup.van-popup--center .popup-content {
  margin-bottom: 20px;
} 
.timetable .van-popup.van-popup--center .popup-content > h2 {
  color: @attendance-color-1;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}
.timetable .van-popup.van-popup--center .popup-content > div {
  color: @attendance-background-color-1;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}
.timetable .van-popup.van-popup--center .popup-content > p {
  color: @attendance-color-2;
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
}
.timetable .popup button {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
  padding: 11px 0;
  border-radius: 3px;
  width: 100%;
  margin-top: 50px;
}
.timetable .van-popup.van-popup--center .popup-content > p > span {
  font-weight: 600;
}
.timetable .timetable_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 10px 15px;
}
.timetable .timetable_top-left {
  display: flex;
  align-items: center;
  justify-content: left;
}
.el-icon-caret-bottom {
  color: #757DA3;
}
.timetable .timetable_top select {
  color: @attendance-color-3;
  border: 0;
  background: none;
  outline: none;
}
.timetable .timetable_top .currentTime {
  width: 34px;
  height: 32px;
  line-height: 32px;
  color: #7469F8;
  font-size: 12px;
  text-align: center;
  border-radius: 50%;
  background: #7469F81E;
}
.timetable .timetable_list {
  display: flex;
  background-color: @attendance-background-color-6;
}
.timetable .timetable_list .period {
  position: relative;
}
.timetable .timetable_list .period > div {
  position: absolute;
  top: 0;
  left: 0;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  // box-shadow: 3px 3px 4px 0px rgba(62, 53, 167, 0.26);
  background: #fff;
  color: #757DA3;
  height: 60px;
  width: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.timetable .timetable_list .period ul {
  margin-top: 60px;
}
.timetable .timetable_list .period ul li {
  height: 131px;
  text-align: center;
  line-height: 131px;
  width: 66px;
}
.timetable .el-tabs__nav .is-top {
  background: @attendance-border-color-5;
  color: @attendance-color-3 !important;
}
.timetable .timetable_list .el-tabs__nav .is-top {
  background: @attendance-border-color-5;
  color: @attendance-color-3;
}
.table_list ul li {
  width: 62px;
  height: 115px;
  background: @attendance-background-color-9;
  color: @attendance-color-3;
  box-sizing: border-box;
  padding: 5px;
  font-size: 12px;
  border-radius: 2px;
}
.timetable .timetable_top .van-cell {
  color: #757DA3;
  padding: 0;
  width: 30%;
}
.timetable .timetable_top .van-field__control {
  color: #757DA3;
}
.timetable_top {
    /deep/.van-field__control {
      color: #757DA3;
    }
  }
.timetable .timetable_top .van-picker-column__item {
  // margin: 0 30%;
}
.timetable .timetable_top .van-cell:not(:last-child)::after {
  border-bottom: 0;
}
.timetable .week-arrow {
  background: url(../../../../static/img/week.png) no-repeat center;
  width: 7px;
  height: 4px;
  background-size: 7px 4px;
}
.timetable
  .timetable_top
  .van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
  color: @attendance-color-1;
  font-weight: 600;
}
.timetable .table-right {
  flex: 1;
  overflow-x: auto;
  background-color: #fff;
  border-top: 1px solid #e5e5e5;
  box-sizing: border-box;
}
.timetable .table-right .week-nav {
  background-color: #fff;
  min-width: 435px;
  box-sizing: border-box;
  border-bottom: 1px solid #e5e5e5;
  height: 60px;
  overflow: hidden;
  box-sizing: border-box;
}
.timetable .table-right .week-nav ul li > p {
  font-size: 14px;
  margin-top: 3px;
}
.timetable .table-right .week-nav .currentDay {
  background-color: #7469F81e;
  color: #7469F8;
  border-radius: 6px;
  transform: scale(0.9);
  transform-origin: center center;
}
.timetable .table-right .week-nav ul li {
  flex-direction: column;
  height: 60px;
  background-color: #fff;
  color: #757DA3;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
}
.timetable .table-right .week-nav ul {
  min-width: 435px;
  display: flex;
  max-width: 100%;
}
.timetable .el-tabs__nav {
  width: 100%;
}
.timetable .period ul li {
  color: @attendance-color-2;
}
.timetable .course-content-box {
  width: 100%;
  position: relative;
  height: calc(~"100% - 60px");
}
.timetable .course-content {
  display: flex;
  min-width: 435px;
  max-width: 100%;
}
.timetable .course-content-box .day-hr {
  position: absolute;
  width: 100%;
  min-width: 435px;
  height: 0;
  border-bottom: 1px dashed #e5e5e5;
}
.timetable .course-content .course-form {
  width: 15%;
  position: relative;
}
.timetable .course-content .course-form ul {
  display: flex;
  flex-direction: column;
}
.timetable .course-content .course-form ul li {
  color: @attendance-color-3;
  font-size: 12px;
  padding: 4px;
  border-radius: 3px;
  word-wrap: break-word;
  position: relative;
  box-sizing: border-box;
}
.timetable .course-content .course-form ul li > p {
  border-radius: 9px;
  background-color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
  text-align: center;
  padding: 2px 0;
  position: absolute;
  bottom: 4px;
  left: 2px;
  width: calc(~"100% - 4px");
  box-sizing: border-box;
  line-height: 14px;
}
.timetable .course-form ul.double-item li {
  height: 131px;
  border-left: 1px solid @attendance-color-3;
  border-top: 1px solid @attendance-color-3;
  z-index: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
}
.timetable .course-form ul.single-item {
  position: relative;
}
.timetable .course-form ul.single-item li {
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
}
.timetable .course-form ul.single-item li.upShow:nth-child(odd) {
  border-bottom: 1px solid @attendance-color-3;
  
}
.timetable .course-form ul.single-item li.upShow:nth-child(2n) {
  border-bottom: 0.5px solid @attendance-color-3;
}
.timetable .van-popup--center {
  width: 90%;
  border-radius: 5px;
}
.timetable .timetable_top input::placeholder {
  color: @attendance-color-3;
}
// .timetable .timetable_top .van-picker__columns::before {
//   width: 120px;
//   height: 1px;
//   background-color: @attendance-background-color-2;
//   content: "";
//   position: absolute;
//   top: 70px;
//   left: 50%;
//   transform: translateX(-50%);
// }
// .timetable .timetable_top .van-picker__columns::after {
//   width: 120px;
//   height: 1px;
//   background-color: @attendance-background-color-2;
//   content: "";
//   position: absolute;
//   bottom: 70px;
//   left: 50%;
//   transform: translateX(-50%);
// }
/* 时间模式 */
.time-right-stu {
  display: flex;
  justify-content: flex-end;
  position: relative;
}
.time-right-stu .van-cell {
  width: calc(~"80% - 25px") !important;
}
.time-right-stu .van-field__control {
  text-align: right;
  padding-right: 25px;
}
.time-right-stu i.week-arrow {
  right: 35px;
  left: unset;
  height: 100%;
}

.timetable .popup_student i.close-pop {
  background: url(../../../../static/img/close.png) no-repeat center;
  position: absolute;
  right: 0;
  top: -10px;
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  padding: 10px;
}
.set-part {
  display: flex;
  justify-content: space-between;
}
.set-part > div {
  width: 48%;
}
.set-part-p {
  text-align: left;
}
.timetable .ul-student {
  width: 99%;
}
.timetable .li-student {
  width: 33%;
  float: left;
  font-size: 15px;
}
.student-tittle-div {
  margin-top: -10px;
}
.student-context-div {
  margin: 0px;
}
.li-student-context {
  width: 33%;
  float: left;
  font-size: 12px;
  color: black;
}
.ul-student-context {
  width: 99%;
  line-height: 20px;
}
.div-backclor1 li {
  background-color: gainsboro;
}
.div-backclor2 li {
  background-color: antiquewhite;
}
.my-swipe {
  width: 100%;
  height: 100%;
  .van-swipe-item {
    padding: 8px 4px;
    box-sizing: border-box;
    color: #fff;
    margin-right: 1px;
    border-radius: 4px;
  }
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}

.timetable .timetable_list .period ul .class_10762 {
    width: 62px;
    height: 131px;
}
.xskcxsPopup{
    width: 334px;
    margin-bottom: 68px;
    margin-left: 12px;
    height: 90px;
    background: #7469f8cc;
    opacity: 0.8;
    box-shadow: 0 3px 6px 0 #5f54e040;
    border-radius: 8px;
    position: fixed;
    bottom: 0;
    padding: 15px;
    z-index: 100;
  }
  .xskcxsPopup .xskcxsPopuptitle{
      color: #fff;
      font-family: PingFangSc-Medium;
      font-weight: 400;
      font-size: 14px;
      float: left;
  }
  .xskcxsPopup .xskcxsPopupxx{
      color: #fff;
      font-family: PingFangSc-Regular;
      font-weight: 400;
      font-size: 12px;
      float: right;
  }
  .xskcxsPopup > div{
      width: 334px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      color: #fff;
      -webkit-box-orient: vertical;
      font-size: 12px;
      line-height: 20px;
  }
  .xskcpopup{
    margin-left: 39px;
    background: #FFF;
    box-shadow: 0 3px 6px 0 #5f54e040;
    border-radius: 8px;
    position: fixed;
    bottom: 250px;
    width: 311px;
    height: 382px;
    z-index: 100;
  }

  .xskcpopup button {
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
    padding: 11px 0;
    border-radius: 3px;
    width: 100%;
    margin-top: 50px;
  }

  .xskcpopup .popup-title {
    background: url(../../../../static/img/chahua.png) no-repeat center;
    width: 100%;
    height: 64px;
  }

  .xskcpopup .popup-title > span{
    color: #fff;
    font-size: 18px;
    line-height: 64px;
    margin-left: 28px;
  }

  .xskcpopup .popup-context {
    margin-top: 10px;
    margin-left: 18px;
    line-height: 20px;
    width: 276px;
    height: 216px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .xskcpopup .popup-float {
   
    width: 100%;
    height: 50px;
  }
  .el-table .gray-row,
  .child-table th {
      background-color: #F6F6F6;
  }

  .xskcxsPopup_bz{
    background: #7469F8;
    z-index: 9999;
    color: #fff;
    padding: 5px 0px 5px 0px;
    min-height: 80px;
    max-height: 160px;
    width: calc(~"100% - 36px");
    height: 120px;
    overflow-y: auto;
    left: 20px;
    
    border-radius: 5px 0px 0px 5px !important;
    bottom: 60px;
  }
  .van-popup-parm{
    width: 100%;
    height: 120px;
    z-index: 1000;
  }
  .xskcxsPopup_bz_context{
      font-size: 14px;
      
    }
  .xskcxsPopup_bz_button{
    width: 10px;
    height: 120px;
    line-height: 120px;
    background: #7469F8;
    z-index: 11111;
    border-radius: 8px;
    color: #fff;
    padding-top: 5px;
    padding-bottom: 5px;
    min-height: 80px;
    max-height: 160px;
    height: 120px;
    overflow-y: auto;
    border-radius: 0px 5px 5px 0px !important;
    left: calc(~"100% - 20px");
    bottom: 60px;
  }  
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/SyKbTable.vue